import {
  logFormConfigurationNotFound,
  logFormConfigurationUsed
} from 'Utils/sentry';

const knownUsageFormIds = [
  'family-dashboard-account-children-form',
  'family-dashboard-account-contact-form',
  'family-dashboard-account-personal-form',
  'family-dashboard-address-delivery-add-form',
  'family-dashboard-address-delivery-edit-form',
  'family-dashboard-address-primary-form',
  'family-dashboard-billing-shipping-addresses-read',
  'family-dashboard-communication-new-customer',
  'family-dashboard-communication-preferences',
  'family-dashboard-communication-preferences-read',
  'family-dashboard-communication-store-preferences',
  'family-dashboard-home-preferences',
  'family-dashboard-login-security',
  'family-dashboard-profile-details-read',
  'family-signup-form',

  'regular-dashboard--personal-form',
  'regular-dashboard-account-personal-form',
  'regular-dashboard-address-delivery-add-form',
  'regular-dashboard-address-delivery-edit-form',
  'regular-dashboard-address-primary-form',
  'regular-dashboard-billing-shipping-addresses-read',
  'regular-dashboard-communication-preferences',
  'regular-dashboard-communication-preferences-read',
  'regular-dashboard-communication-store-preferences',
  'regular-dashboard-home-preferences',
  'regular-dashboard-login-security',
  'regular-dashboard-profile-details-read',
  'regular-upgrade-form'
];

const trackedFormIds = new Set(knownUsageFormIds);
const missingFormIds = new Set();

// Base form configurations injected by Webpack's DefinePlugin at the build time
// Using a Proxy to track and report
// form configuration keys are accessed or missing
const forms = new Proxy(FORM_CONFIG, {
  get(target, prop) {
    const isMissing = !(prop in target);
    const isReported = missingFormIds.has(prop);

    // Report form configuration status once per session
    // even if it has known usage in another locale
    if (isMissing && !isReported) {
      missingFormIds.add(prop);
      logFormConfigurationNotFound(prop);
    }

    // Track form configuration usage only when it's not known
    if (!trackedFormIds.has(prop)) {
      trackedFormIds.add(prop);
      logFormConfigurationUsed(prop);
    }

    return isMissing ? undefined : target[prop];
  }
});

export default forms;
